<template>
  <mu-card id="mood-input" class="aio-input">
    <mu-card-actions class="aio-input-header pointer" @click.native="openInput">
      <mu-flexbox justify="flex_start" style="height: 48px">
        <svg class="card-left-icon" width="22px" height="22px" viewBox="19 193 17 14" version="1.1"
             xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <!-- Generator: Sketch 40.3 (33839) - http://www.bohemiancoding.com/sketch -->
          <desc>Created with Sketch.</desc>
          <defs></defs>
          <g id="moodIcon" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"
             transform="translate(20.000000, 193.000000)">
            <path
              d="M15.728,2.30929587 C15.6869333,2.24827023 15.6218667,2.20673177 15.5477333,2.19391126 L15.5424,2.19339844 C14.8528,2.41134716 13.3312,2.39083433 11.6,2.10109075 C9.8688,1.81134716 8.432,1.33596254 7.85813333,0.906731771 L7.85386667,0.90621895 C7.77973333,0.893911258 7.70346667,0.911859976 7.64373333,0.95596254 C7.584,1.0000651 7.54613333,1.06621895 7.53973333,1.137501 L7.32053333,3.53442408 C7.384,3.52519331 7.44693333,3.51442408 7.51093333,3.51442408 C7.78453333,3.51442408 8.04693333,3.59391126 8.27093333,3.74570613 C8.4992,3.89955228 8.66826667,4.11852664 8.75946667,4.36724459 C8.92,4.25391126 9.16213333,4.17544972 9.43893333,4.16468049 C9.93386667,4.14673177 10.344,4.34980869 10.3546667,4.61801382 C10.3658667,4.88570613 9.97173333,5.11801382 9.4768,5.13544972 C9.24853333,5.14365485 9.04106667,5.10314203 8.87946667,5.03288562 L9.2112,7.45185998 C9.59733333,7.0949369 10.1445333,6.90980869 10.7125333,7.00468049 C11.5706667,7.14827023 12.1706667,7.8749369 12.1525333,8.68775741 C12.1525333,8.6949369 12.1493333,8.7000651 12.1434667,8.70519331 C12.1381333,8.70929587 12.1317333,8.71134716 12.1248,8.70980869 L9.3184,8.2400651 L9.52853333,9.76775741 C9.54613333,9.91083433 9.55573333,10.0539113 9.55946667,10.1949369 C9.73706667,10.2528856 9.92,10.3016036 10.1093333,10.3339113 C11.9872,10.6482702 13.8090667,9.54365485 14.3205333,7.77903946 L15.7594667,2.51442408 C15.7813333,2.44519331 15.7685333,2.37032151 15.728,2.30929587 L15.728,2.30929587 Z M13.5541333,5.5200651 C13.4506667,5.76878305 12.9936,5.82673177 12.5328,5.64827023 C12.0736,5.47032151 11.7856,5.12468049 11.8885333,4.87596254 C11.9925333,4.62775741 12.4501333,4.56980869 12.9098667,4.74775741 C13.3696,4.92570613 13.6581333,5.27134716 13.5541333,5.5200651 L13.5541333,5.5200651 Z"
              id="Shape" fill="#8150E4"></path>
            <path
              d="M7.76586667,4.75544972 C7.75626667,4.68724459 7.71786667,4.62621895 7.6592,4.58621895 C7.61546667,4.55647536 7.56426667,4.54160357 7.512,4.54160357 C7.49386667,4.54160357 7.47573333,4.54365485 7.45706667,4.54724459 L7.4528,4.54827023 C6.92693333,4.97852664 5.5808,5.48775741 3.94773333,5.83185998 C2.8784,6.05698818 1.89013333,6.16929587 1.14826667,6.16929587 C0.757333333,6.16929587 0.4352,6.137501 0.205333333,6.07596254 L0.201066667,6.07698818 C0.1312,6.09134716 0.0709333333,6.13339844 0.0346666667,6.19339844 C-0.0016,6.25288562 -0.0096,6.32416767 0.0112,6.38980869 L1.60533333,11.3364754 C2.0896,12.7569882 3.46346667,13.6764754 4.96106667,13.6764754 C5.21173333,13.6764754 5.4656,13.6508343 5.71946667,13.597501 C7.49066667,13.2236548 8.68,11.6210907 8.47093333,9.88980869 L7.76586667,4.75544972 L7.76586667,4.75544972 Z M2.1568,8.79647536 C2.1552,8.54211639 2.536,8.33339844 3.00746667,8.33032151 C3.47893333,8.32673177 3.8624,8.53288562 3.864,8.78724459 C3.8656,9.04211639 3.4848,9.25134716 3.01333333,9.25391126 C2.5424,9.25647536 2.15893333,9.05185998 2.1568,8.79647536 L2.1568,8.79647536 Z M5.37333333,12.0785266 C4.59306667,12.2426292 3.82293333,11.8492959 3.5088,11.1744241 C3.4976,11.1492959 3.4976,11.1210907 3.5104,11.0964754 C3.5232,11.0713472 3.54666667,11.0544241 3.57493333,11.0482702 L6.5584,10.4185266 C6.58613333,10.4128856 6.61493333,10.4190395 6.63733333,10.4364754 C6.65973333,10.4533984 6.67253333,10.4795523 6.67306667,10.5067318 C6.6816,11.246219 6.15306667,11.9144241 5.37333333,12.0785266 L5.37333333,12.0785266 Z M6.2864,8.56365485 C5.85653333,8.75032151 5.41973333,8.71442408 5.3104,8.48211639 C5.20053333,8.24929587 5.45973333,7.90980869 5.88906667,7.72314203 C6.31893333,7.53647536 6.75573333,7.5723728 6.86506667,7.80416767 C6.97493333,8.03647536 6.71626667,8.37647536 6.2864,8.56365485 L6.2864,8.56365485 Z"
              id="Shape" fill="#8150E4"></path>
          </g>
        </svg>
        <mu-flexbox-item class="left16" v-text="title"></mu-flexbox-item>
        <mu-flexbox-item align="right">
          <mu-icon-button
            class="card-bar-icon blueIcon"
            :icon="isOpenInput ? 'remove_circle_outline' : 'add_circle'"
          ></mu-icon-button>
        </mu-flexbox-item>
      </mu-flexbox>
    </mu-card-actions>
    <form v-if="isOpenInput">
      <mu-card-text>
        <div class="upper-label">
          <mu-icon :size="12" value="flash_on"></mu-icon>
          {{$t('message.labelEnergy')}}
        </div>
        <mu-row v-for="(group, groupIndex) in moods.energy" :key="'mood-group-1' + groupIndex" class="bottom">
          <mu-col v-for="item, index in group" :key="'group-inner-1-' + index" width="20" tablet="20" desktop="20"
                  align="center">
            <div class="hvr-grow pointer" @click="toggleMood(item)" v-bind:class="{isActiveMood: item.isActive}">
              <div class="moodButton">
                <div class="moodToggle"></div>
                <img width="48" :src="item.icon"/>
              </div>
              <div style="font-size: 12px;">{{$t(localizeMood(item.mood))}}</div>
            </div>
          </mu-col>
        </mu-row>
        <div class="upper-label">
          <mu-icon :size="12" value="thumb_up"></mu-icon>
          {{$t('message.labelMood')}}
        </div>
        <mu-row v-for="(group, groupIndex) in moods.mood" :key="'mood-group-2' + groupIndex" class="bottom">
          <mu-col v-for="item, index in group" :key="'group-inner-2' + index" width="20" tablet="20" desktop="20"
                  align="center">
            <div class="hvr-grow pointer" @click="toggleMood(item)" v-bind:class="{isActiveMood: item.isActive}">
              <div class="moodButton">
                <div class="moodToggle"></div>
                <img width="48" :src="item.icon"/>
              </div>
              <div style="font-size: 12px;">{{$t(localizeMood(item.mood))}}</div>
            </div>
          </mu-col>
        </mu-row>
        <div class="upper-label">
          <mu-icon :size="12" value="favorite"></mu-icon>
          {{$t('message.labelHealth')}}
        </div>
        <mu-row v-for="(group, groupIndex) in moods.health" :key="'mood-group-3' + groupIndex" class="bottom">
          <mu-col v-for="(item, index) in group" :key="'group-inner-3' + index" width="20" tablet="20" desktop="20"
                  align="center">
            <div class="hvr-grow pointer" @click="toggleMood(item)" v-bind:class="{isActiveMood: item.isActive}">
              <div class="moodButton">
                <div class="moodToggle"></div>
                <img width="48" :src="item.icon"/>
              </div>
              <div style="font-size: 12px;">{{$t(localizeMood(item.mood))}}</div>
            </div>
          </mu-col>
        </mu-row>
      </mu-card-text>
    </form>
  </mu-card>
</template>
<script>

  import 'hover.css/css/hover.css'
  
  import MoodLocalizerMixin from '../../../../mixins/Localization/Moods/MoodLocalizerMixin'

  export default {
    name: 'aio-mood',
    mixins: [MoodLocalizerMixin],
    data() {
      return {
        title: this.$t('message.cardMood'),
        isOpen: false,
        isOpenInput: false,
        isSaving: false,
        isBackgroundShown: true,
        hasData: false,
        noData: false,
        loading: true,
        data: {},
        moods: {},
        model: {
          moods: []
        }
      }
    },
    watch: {
      'model.moods': function () {
        this.trySubmitAndEmitValue();
      }
    },
    mounted() {
      let self = this;
      self.moods = JSON.parse(JSON.stringify(self.$store.state.moodList));
    },
    methods: {
      trySubmitAndEmitValue() {
        let self = this;
        if (self.model.moods.length > 0) {
          self.$emit('onValid', self.model);
        }
        else self.$emit('onValid', null);
      },
      getImageUrl(mood) {
        return config.siteUrl + 'assets/moods/svg/' + mood.icon + '.svg'
      },
      toggleMood(mood) {
        let self = this;
        mood.isActive = !mood.isActive;
        if (mood.isActive === true) {
          self.model.moods.push(mood.mood_id);
        }
        if (mood.isActive === false) {
          const index = self.model.moods.indexOf(mood.mood_id);
          self.model.moods.splice(index, 1);
        }
        self.$forceUpdate();
      },
      closeInput() {
        let self = this;
        self.isOpenInput = false;
        self.$emit('onValid', null);
        self.$forceUpdate();
      },
      openInput() {
        let self = this;
        self.isOpenInput = !self.isOpenInput;
        self.model.moods = [];
        self.$emit('onValid', null);
        self.moods = JSON.parse(JSON.stringify(self.$store.state.moodList));
      },
    }
  }
</script>
<style scoped>
  .moodToggle {
    border-radius: 50%;
    height: 16px;
    width: 16px;
    box-shadow: 0px 1px 4px black;
    position: absolute;
    right: 1px;
    bottom: 24px;
    z-index: 1;
    background: white;
    border: 4px solid white;
  }

  .moodButton img {
    height: 48px;
  }

  .isActiveMood .moodToggle {
    background: #66B817;
  }

  .pointer {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// Mood.vue?0ea6ac60